(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formfit-customer-photos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-customer-gallery')) {
    customElements.define('ff-customer-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.galleryReady) return;
        this.galleryReady = true;
        this.links = [...this.querySelectorAll('[data-photo]')];
        this.rail = this.querySelector('.ff-customer-photos__rail');
        this.dialog = this.querySelector('dialog');
        this.fullImage = this.querySelector('[data-full-image]');
        this.index = 0;
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-photo]');
          if (photo && !event.ctrlKey && !event.metaKey && !event.shiftKey && typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            this.opener = photo;
            this.showPhoto(this.links.indexOf(photo));
            this.dialog.showModal();
          }
          if (event.target.closest('[data-close]')) this.dialog.close();
          const step = event.target.closest('[data-step]');
          if (step) this.showPhoto(this.index + Number(step.dataset.step));
          const scroll = event.target.closest('[data-scroll]');
          if (scroll) this.rail.scrollBy({left:Number(scroll.dataset.scroll) * (this.links[0].offsetWidth + 16), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        this.dialog.addEventListener('close', () => this.opener?.focus({preventScroll:true}));
        this.updateRail = () => {
          const controls = this.querySelector('[data-rail-controls]');
          if (!controls) return;
          controls.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 2;
          controls.querySelector('[data-scroll="-1"]').disabled = this.rail.scrollLeft <= 2;
          controls.querySelector('[data-scroll="1"]').disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
        };
        this.rail.addEventListener('scroll', this.updateRail, {passive:true});
        this.observer = new ResizeObserver(this.updateRail);
        this.observer.observe(this.rail);
        this.updateRail();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      showPhoto(index) {
        this.index = (index + this.links.length) % this.links.length;
        const photo = this.links[this.index];
        this.fullImage.src = photo.href;
        this.fullImage.alt = photo.querySelector('img').alt;
        this.fullImage.hidden = false;
        this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.links.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
